/* HADARA · CATALOGUE HELPERS
   Filtering runs inside sections/catalogue.liquid so multiple catalogue sections
   can coexist on one page. This exposes the tag helpers for custom work. */
window.HadaraCatalogue = {
  parseTag: function (tag) {
    var i = tag.indexOf(':');
    return i === -1 ? { facet: '', value: tag } : { facet: tag.slice(0, i).trim(), value: tag.slice(i + 1).trim() };
  },
  linkFor: function (tag) { return '/pages/catalogue?filter=' + encodeURIComponent(tag); },
  linkForSearch: function (q) { return '/pages/catalogue?q=' + encodeURIComponent(q); }
};
